module.exports = __webpack_public_path__ + "static/media/dice.51a9d64a.svg";